const { hostname } = window.location;

const getEnv = () => {
  if (hostname.indexOf('test') > -1) {
    return 'test';
  }
  if (hostname.indexOf('dev') > -1) {
    return 'dev';
  }
  if (hostname.indexOf('localhost') > -1) {
    return 'local';
  }
  return 'prod';
};

export const env = getEnv();
